const FEE_TYPE_DISPLAY_NAMES: Record<string, string> = {
  reseller_fee: "Agent Fee",
  provider_fee: "Provider Fee",
  payout: "Payout",
  withdrawal: "Withdrawal",
};

export const getFeeTypeDisplayName = (type: string): string => {
  return FEE_TYPE_DISPLAY_NAMES[type] || type.replace(/_/g, " ").replace(/\b\w/g, (c) => c.toUpperCase());
};
